import { useState, useEffect } from 'react'
import managerSettingsFns from '../../../utils/helpers/managerSettingsFns'

const useManagerSettings = (locationId) => {
    const [settings, setSettings] = useState(managerSettingsFns.getDefaultSettings())

    useEffect(() => {
        if (locationId) {
            setSettings(managerSettingsFns.getSettings(locationId))
        }
    }, [locationId])

    const updateSettings = (newSettings) => {
        // Pure localStorage write + React state update — no API calls
        setSettings(managerSettingsFns.saveSettings(locationId, newSettings))
    }

    return { settings, updateSettings }
}

export default useManagerSettings
